import { Admin } from '../types';

export function hasPermission(admin: Admin | null, resource: string, action: string): boolean {
  if (!admin) return false;
  if (!admin.permissions || !admin.roles) return false;
  // Индивидуальные права
  if (admin.permissions.some(p => p.resource === resource && p.action === action)) return true;
  // Права через роли
  for (const role of admin.roles) {
    if (role.permissions && role.permissions.some(p => p.resource === resource && p.action === action)) return true;
  }
  return false;
}

// Permissions for sliders and slider categories
export const SLIDER_PERMISSIONS = [
  { resource: 'sliders', action: 'read', label: 'Просмотр слайдов' },
  { resource: 'sliders', action: 'create', label: 'Создание слайдов' },
  { resource: 'sliders', action: 'update', label: 'Редактирование слайдов' },
  { resource: 'sliders', action: 'delete', label: 'Удаление слайдов' },
  { resource: 'slider_categories', action: 'read', label: 'Просмотр категорий слайдеров' },
  { resource: 'slider_categories', action: 'create', label: 'Создание категорий слайдеров' },
  { resource: 'slider_categories', action: 'update', label: 'Редактирование категорий слайдеров' },
  { resource: 'slider_categories', action: 'delete', label: 'Удаление категорий слайдеров' },
]; 